namespace $.$$ {

	export class $shm_projects_task_chat extends $.$shm_projects_task_chat {

		override chat_title() {
			return 'AI-агент'
		}

		override chat_body() {
			return [ this.Process_view() ]
		}

		override Sessions_pick() {
			return null as any
		}

		override Goal_settings() {
			return null as any
		}

		override Chat_provider() {
			return null as any
		}

		override message_time( id: string ) {
			return ''
		}

		override chat_status() {
			const run = this.run() as $shm_projects_goal_run | null
			if( !run ) return 'Готов'
			if( run.status === 'queued' && !run.workspace ) return 'Подготовка workspace'
			if( run.status === 'queued' || run.status === 'running' ) return 'Выполняется'
			if( run.status === 'waiting' ) return 'Ожидает ответа'
			if( run.status === 'failed' ) return 'Ошибка'
			if( run.status === 'stopped' ) return 'Остановлено'
			return 'Готов'
		}

		@ $mol_mem
		refresh( next?: number ) {
			return next ?? 0
		}

		override message_items() {
			this.refresh()
			const run = this.run() as $shm_projects_goal_run | null
			if( !run ) return []
			return Array.from( { length: run.iteration }, ( _, index )=> index + 1 )
				.flatMap( iteration => ( this as any ).iteration_messages( run, iteration ) )
		}

	}

}
